module.exports = __webpack_public_path__ + "static/media/black_filter_icon.ca092626.svg";